import React from 'react';
import PropTypes from "prop-types";

import styles from "./DashboardRadio.module.css";
import classNames from 'classnames';

export default function DashboardRadio({isSelected, onChange, value, label, disabled = false, containerClassName, name = 'dashboardRadio'}){

  return (
    <div className={classNames(styles.container, containerClassName)}>
      <input
        type="radio"
        id={`${name}-${value}`}
        checked={isSelected}
        onChange={() => onChange(value)}
        value={value}
        disabled={disabled}
        name={name}
      />
      {label && <label className={styles.radio_label} htmlFor={`${name}-${value}`}>{label}</label>}
    </div>
);
};

DashboardRadio.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string,
    name: PropTypes.string,
}